/**
 * ShopCardsContainer — список товаров магазина (скролл SimpleBar)
 */

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ucpService } from "../../api/services/ucpService";
import { getShopImageCandidates } from "../../utils/helpers";

const CATEGORY_INDEX = {
    premium: 1,
    accessories: 2,
    tp: 3,
    coupons: 4,
    costumes: 5,
    weapons: 6,
    kits: 7,
    boxes: 8,
    cabarets: 9,
    other: 10,
};

const ShopCardsContainer = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const category = searchParams.get("category") || "main";
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [items, setItems] = useState([]);
    const [favoriteItems, setFavoriteItems] = useState(new Set());
    const [loading, setLoading] = useState(true);
    const [errorText, setErrorText] = useState("");
    const filteredItems = items.filter(
        (item) =>
            category === "main" || CATEGORY_INDEX[category] === item.category,
    );

    const fetchShopData = async () => {
        setLoading(true);
        setErrorText("");
        try {
            const [favResult, allItems] = await Promise.all([
                ucpService.getFavouriteItems(),
                ucpService.getShopItems(),
            ]);
            setFavoriteItems(new Set(favResult || []));
            setItems(allItems || []);
        } catch (err) {
            console.error("Ошибка загрузки магазина:", err.message);
            setErrorText("Не удалось загрузить товары.");
            setFavoriteItems(new Set());
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchShopData();
    }, []);

    const toggleFavorite = async (itemId) => {
        try {
            if (favoriteItems.has(itemId)) {
                await ucpService.deleteFromFavourites(itemId);
            } else {
                await ucpService.putInFavourites(itemId);
            }

            setFavoriteItems((prev) => {
                const newFavorites = new Set(prev);
                if (newFavorites.has(itemId)) {
                    newFavorites.delete(itemId);
                } else {
                    newFavorites.add(itemId);
                }
                return newFavorites;
            });
        } catch (err) {
            console.error("Ошибка при обновлении избранного:", err.message);
        }
    };

    const handleBuyItem = (itemId) => {
        navigate(`/ucp/shop/buy?item_id=${encodeURIComponent(itemId)}`);
    };

    if (loading) {
        return (
            <div className="shop-loader-container">
                <div className="shop-loader"></div>
            </div>
        );
    }

    return (
        <SimpleBar className="simplebar-track-shop">
            <div className="shop-cards-container">
                {errorText ? (
                    <p className="loading-text">{errorText}</p>
                ) : filteredItems.length > 0 ? (
                    filteredItems.map((item) => (
                        <div
                            key={item.id}
                            className="shop-card"
                            onMouseEnter={() => setHoveredIndex(item.id)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div className="information-container-body-shop">
                                <img
                                    src={getShopImageCandidates(item.imgUrl)[0]}
                                    alt={item.name || "shop item"}
                                    loading="lazy"
                                    onError={(event) => {
                                        const candidates =
                                            getShopImageCandidates(item.imgUrl);
                                        const currentIndex = Number(
                                            event.currentTarget.dataset
                                                .candidateIndex || 0,
                                        );
                                        const nextIndex = currentIndex + 1;
                                        if (nextIndex >= candidates.length) {
                                            return;
                                        }
                                        event.currentTarget.dataset.candidateIndex =
                                            String(nextIndex);
                                        event.currentTarget.src =
                                            candidates[nextIndex];
                                    }}
                                />
                                <button
                                    className={`shop-favorite-button ${favoriteItems.has(item.id) ? "active" : ""}`}
                                    onClick={() => toggleFavorite(item.id)}
                                ></button>
                            </div>
                            <span className="shop-card-title">{item.name}</span>
                            <button
                                className="shop-primary-button shop-card-buy-button"
                                type="button"
                                onClick={() => handleBuyItem(item.id)}
                            >
                                {hoveredIndex === item.id
                                    ? "КУПИТЬ"
                                    : `${item.price} MD`}
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="loading-text">Товары не найдены.</p>
                )}
            </div>
        </SimpleBar>
    );
};

export default ShopCardsContainer;
